module.exports = __webpack_public_path__ + "dk.svg?6227fcc5447bbd9d36b0cdfd2ea0c33c";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/dk.svg
// module id = 985
// module chunks = 27